import { render, staticRenderFns } from "./RelaySchedule.vue?vue&type=template&id=015f32fe&"
import script from "./RelaySchedule.vue?vue&type=script&lang=ts&"
export * from "./RelaySchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports